import { Link } from "react-router-dom";

const STEPS = [
  { n: 1, label: "Closet ingest", to: "/seller/add" },
  { n: 2, label: "AI studio", to: "/seller/photoshoot" },
  { n: 3, label: "Publish", to: "/seller/products" },
];

export default function SellerFlowSteps({ current = 1 }) {
  return (
    <ol className="flex flex-wrap items-center gap-2 mb-8" data-testid="seller-flow-steps">
      {STEPS.map((step, i) => {
        const active = step.n === current;
        const done = step.n < current;
        return (
          <li key={step.n} className="flex items-center gap-2">
            {i > 0 && <span className="text-aura-border px-1">→</span>}
            <Link
              to={step.to}
              className={`inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-full border ${
                active
                  ? "border-aura-accent bg-aura-accent text-white"
                  : done
                    ? "border-aura-border text-aura-ink"
                    : "border-aura-border text-aura-muted"
              }`}
            >
              <span className="font-mono">{step.n}</span>
              {step.label}
            </Link>
          </li>
        );
      })}
    </ol>
  );
}
